import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContainerResizeListener from '../ContainerResizeListener';
import IconStand from '../../widgets/Status/IconStand';
import ShipmentStatusIcon from '../../widgets/Status/ShipmentStatus/ShipmentStatusIcon';
import { getTranslatedInfo, errorTypes } from './errorMessageHelper';

import './ErrorPage.module.scss';

function ErrorPage({ type, language }) {
  const [isMobile, setMobile] = useState(0);
  const { title, message } = getTranslatedInfo(type, language);

  return (
    <ContainerResizeListener
      styleName={classNames('container', { mobile: isMobile })}
      onResize={({ width }) => setMobile(width <= 768)}
    >
      <IconStand size={isMobile ? 116 : 186} iconBackgroundColor="#00B1E1">
        <ShipmentStatusIcon name={getIcon(type)} size={isMobile ? 48 : 64} fill="#FFFFFF" />
      </IconStand>
      <span styleName="title">{title}</span>
      <span styleName="sub-title">{message}</span>
    </ContainerResizeListener>
  );
}

const iconTypes = {
  infoGeneral: 'info-general',
  lost: 'lost',
};

function getIcon(errorType) {
  return errorType === errorTypes.noInfo ? iconTypes.infoGeneral : iconTypes.lost;
}

ErrorPage.propTypes = {
  type: PropTypes.oneOf(['not-found', 'error', 'no-info']).isRequired,
  language: PropTypes.string,
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/js/components/ErrorPage/ErrorPage.js